import { Card, Checkbox, Col, Label, OutlineButton, PopupDialogbox, PrimaryButton, ReactSelectBox, Row, Tooltip } from "client/CommonComponents";
import permissions, { isAuthorized } from "client/utils/Permissions";

const OrderType = (props: any) => {
    const {
        orderTypeDropdownList,
        costCenterDropdownList,
        onChangeCostCenter,
        onChangeOrderType,
        selectedCostCenter,
        selectedOrderType,
        validation,
        BulkOrdeByIdValue,
        Popupcontent,
        hideDialog,
        isApprovalOverride,
        handlePreAuthorizedFlagChange,
        cancelOrderReq,
        isCostCenterAvailableForSubmit
    } = props; 
    return (
        <>
        <Card data-attribute="OrderType_Default_Card">
                <Row>
                    <Col xs={12} sm={4} md={3} lg={3} className='mb-md-0 mb-2'>
                        <p className='headingText mb-0'>CREATE BULK ORDER</p>
                        <p className='subText'>Select below options to create bulk order</p>
                    </Col>
                    <Col xs={12} sm={4} md={3} lg={3} className='mt-2 mt-sm-0 mb-md-0 mb-2'>
                        {BulkOrdeByIdValue ?
                            <>
                                <p className='flexDisplay'>
                                    <p className='createdText'> Created By - </p>
                                    <Tooltip content={BulkOrdeByIdValue?.requestedBy ? BulkOrdeByIdValue?.requestedBy : "-"} data-attribute="OrderType_Default_Tooltip">
                                        <p className='createdContent'>{BulkOrdeByIdValue?.requestedBy ? BulkOrdeByIdValue?.requestedBy : "-"}</p>
                                    </Tooltip>
                                </p>
                            </>
                            : null
                        }
                    </Col>
                </Row>
            <Row>
                <Col xs={12} sm={4} md={3} lg={3} className='mb-md-0 mb-2'>
                    <div>
                        <Label required data-attribute="OrderType_Default_Label">Order Type</Label>
                        <ReactSelectBox
                            options={orderTypeDropdownList}
                            placeholder="Select Order Type"
                            onChange={onChangeOrderType}
                            value={selectedOrderType?.hasOwnProperty("label") ? selectedOrderType : ""}
                            className={validation.orderTypeError ? 'controlValidation' : ""}
                         data-attribute="OrderType_Default_SearchSelectBox" />
                        {validation.orderTypeError ? <p className='validMessage'>{validation.orderTypeError}</p> : ""}
                    </div>
                </Col>
                <Col xs={12} sm={4} md={3} lg={3} className='mt-2 mt-sm-0 mb-md-0 mb-2'>
                    <div>
                        <Label required data-attribute="OrderType_Default_Label_2">Cost Center</Label>
                        <ReactSelectBox
                            options={costCenterDropdownList}
                            placeholder="Select Cost Center"
                            onChange={onChangeCostCenter}
                            value={selectedCostCenter?.hasOwnProperty("label") ? selectedCostCenter : ""}
                            isSearchable={true}
                            isDisabled = {BulkOrdeByIdValue ? true : false}
                            className={validation.costCenterError ? 'controlValidation' : ""}
                         data-attribute="OrderType_Default_SearchSelectBox_2" />
                        {validation.costCenterError ? <p className='validMessage'>{validation.costCenterError}</p> : ""}
                    </div>
                    {!isCostCenterAvailableForSubmit  ? <p className="branch-error"><b>Note:</b> Branch is not available in your location, please save if available.</p> : null}
                </Col>
                <Col xs={12} sm={4} md={3} lg={1} className='add-item-buttons'>
                    <PrimaryButton text='Add Item' onClick={props?.onAddItemClick}  data-attribute="OrderType_Default_Button" />
                </Col>
                <Col xs={12} sm={4} md={3} lg={3} className='add-item-buttons add-Auth-Checkbox'>
                  {isAuthorized(permissions.SetPreAuthorized) ? <Checkbox 
                    label='Approval Override(Pre-Authorized)' 
                    className='mb-0 mt-sm-2 pull-right' 
                    checked={isApprovalOverride ? true : false} 
                    onChange={(e: any, value: any)=>handlePreAuthorizedFlagChange(e, value)}
                     data-attribute="OrderType_Approval_Override_Pre_Authorized_Checkbox" /> : null}
                </Col>
                    {BulkOrdeByIdValue ?
                        <Col xs={12} sm={4} md={3} lg={2} className='cancel-request-btn'>
                            <OutlineButton
                                text='Cancel Request'
                                onClick={() => cancelOrderReq()}
                                disabled={!isAuthorized(permissions?.CreateUpdateBulkOrder)}
                             data-attribute="OrderType_Default_Button_2" />
                        </Col>
                        : null
                    }
            </Row>
        </Card>
        {Popupcontent.isDialogVisible ? 
           <PopupDialogbox
           hideDialog={!Popupcontent.isDialogVisible}
           onDismiss={hideDialog}
           Popupcontent={Popupcontent}
           popupOutlinebtnOnclick={Popupcontent?.popupOutlinebtnOnclick}
           popupPrimarybtnOnclick={(
             item: any,
             actionby: string,
             value: any
           ) => {
            Popupcontent?.popupPrimarybtnOnclick(
               item,
               actionby,
               value
             );
           }}
          data-attribute="OrderType_Default_PopupDilalogBox" /> : ""
        }
        </>
    )
}

export default OrderType;